import * as PropTypes from 'prop-types'

const AlarmShape = PropTypes.shape({

})

export { AlarmShape }
